import { useCallback } from 'react';
import { useGetIdentity } from 'react-admin';
import { supabase } from '../providers/supabase/supabase';

export type CropClassesCsvRow = {
    Crop?: string;
    crop?: string;
    State?: string;
    state?: string;
    AIP?: string;
    aip?: string;
    Class?: string;
    class?: string;
};

function normalizeRow(raw: CropClassesCsvRow) {
    const crop = (raw.Crop ?? raw.crop ?? '').toString().trim();
    const state = (raw.State ?? raw.state ?? '').toString().trim();
    const aip = (raw.AIP ?? raw.aip ?? '').toString().trim();
    const cls = (raw.Class ?? raw.class ?? '').toString().trim();

    return { crop, state, aip, class: cls, spreadsheet_type: 'csv-upload' };
}

export function useCropClassesImport() {
    const user = useGetIdentity();

    const processBatch = useCallback(
        async (batch: CropClassesCsvRow[]) => {
            const rows = batch
                .map(normalizeRow)
                .filter(r => r.crop && r.state && r.aip);

            if (rows.length === 0) return;

            const { error } = await supabase.from('crop_classes').insert(rows);

            if (error) {
                console.error('Crop classes import batch error:', error);
                throw error;
            }
        },
        [user?.identity?.id]
    );

    return { processBatch };
}
